const backToTop = () => {
  const backToTopButton = document.querySelector(".footer__back-to-top");

  if (!backToTopButton) {
    return;
  }

  // @todo add easing/slower scroll if requested.
  backToTopButton.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
};

backToTop();
